import type { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';

export const DEFAULT_FORMAT_DATE = 'YYYY/MM/DD';

export const disabledDateBeforeToday: RangePickerProps['disabledDate'] = (current) =>
  // Can not select days before today
  current && current < dayjs().startOf('day');
